import CheckCircleOutlined from "@mui/icons-material/CheckCircleOutlined";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import WarningAmber from "@mui/icons-material/WarningAmber";

import { AlertLevel } from "./AlertContextProvider.types";

const iconSx = { height: 22, width: 22 };

export function AlertMessageIcon({ level }: { level: AlertLevel }) {
  switch (level) {
    case "error":
      return <WarningAmber sx={iconSx} />;
    case "warning":
    case "info":
      return <InfoOutlined sx={iconSx} />;
    case "success":
      return <CheckCircleOutlined sx={iconSx} />;
  }
}
